module.exports = __webpack_public_path__ + "static/media/man.244a7490.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/th/man.gif
// module id = 1007
// module chunks = 0